import React, {ChangeEvent, useState} from "react";
import Modal, {ModalBody, ModalFooter, ModalHeader, ModalTitle} from '@atlaskit/modal-dialog';
import {Menu} from "navigation-common/types/navigation-types";
import Button from "@atlaskit/button/new";
import Toggle from '@atlaskit/toggle';

export const ImportConfirmModal = ({menuToImport, onImport, onCancel}: { menuToImport: Menu, onImport: (menu: Menu) => void, onCancel: () => void }) => {
    const [isImporting, setIsImporting] = useState(false);

    const handleClickedImport = () => {
        if (menuToImport) {
            setIsImporting(true);
            onImport(menuToImport);
        }
    };

    return (
        <Modal width={"medium"}>
            <ModalHeader>
                <ModalTitle>Import menu</ModalTitle>
            </ModalHeader>
            <ModalBody>
                <div style={{marginBottom: "24px"}}>
                    <p><strong>User group</strong> and <strong>space category</strong> settings will not be imported since the exported settings do not always
                        match the configuration of the new target system.</p>
                </div>
                <div style={{marginBottom: "24px"}}>
                    <div><strong>Visibility</strong></div>
                    The menu is active and visible for Confluence users after import
                    <Toggle id="toggle-visibility" size="large" defaultChecked={menuToImport.active}
                            onChange={(e: ChangeEvent<HTMLInputElement>) => menuToImport.active = e.target.checked}/>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button appearance="subtle" onClick={onCancel}>Cancel</Button>
                <Button isLoading={isImporting} appearance="primary" onClick={handleClickedImport} autoFocus>
                    Import menu
                </Button>
            </ModalFooter>
        </Modal>
    );
}
